import { __assign } from "tslib";
import * as React from 'react';
function IconSearchSizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.05 15.463a7.5 7.5 0 111.414-1.414l6.542 6.542-1.415 1.415-6.542-6.543zM15 9.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z" })));
}
export default IconSearchSizeM;
